module.exports = __webpack_public_path__ + "img/Bouclier02.7f1500d2.png";